import Fingerprint2 from 'fingerprintjs2';

export default async () => {
  const components = await Fingerprint2.getPromise();
  const fingerprint = components.map(component => component.value).join('');
  const transformedComponents = {};
  components.forEach((component) => {
    transformedComponents[component.key] = component.value;
  });
  
  const {
    colorDepth, screenResolution, timezone, timezoneOffset, language, userAgent,
  } = transformedComponents;
  return {
    deviceId: Fingerprint2.x64hash128(fingerprint, 31),
    screenResolution: {
      width: screenResolution[1],
      height: screenResolution[0],
      ratio: window.devicePixelRatio,
    },
    userAgent,
    timezone,
    language,
    acceptHeader: 'application/json',
    colorDepth,
    timeZoneOffset: timezoneOffset,
    javaEnabled: window.navigator?.javaEnabled(),
  };
};
